import { createAction, handleActions } from 'redux-actions';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { requestDMPost } from 'modules/fetch/api';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import axios from 'axios';
import Uuid4 from 'uuid/v4';
import { activeCount,isACtiveSatisfyModal, isActiveOrganizationModal, isActiveComplaintModal, isActiveComplaintSearchModal, loading } from 'modules/actions/statusMenu';
const GET_CHAT_LIST = 'chat/GET_CHAT_LIST';
const GET_CHAT_RESULT = 'chat/GET_CHAT_RESULT';
const GET_CHAT_LOADING = 'chat/GET_CHAT_LOADING';
const SET_CHAT_LIST = 'chat/SET_CHAT_LIST';
const INSERT_CHAT = 'chat/INSERT_CHAT';
const CHANGE_CHAT = 'chat/CHANGE_CHAT';
const RE_RENDER_CHAT = 'chat/RE_LOAD_CHAT';

export const reRenderChat = createAction(RE_RENDER_CHAT);
export const insertChat = createAction(INSERT_CHAT);
export const changeChat = createAction(CHANGE_CHAT);

// message set
export const chatList = createAction(GET_CHAT_LIST);
export const setChatList = createAction(SET_CHAT_LIST);

const domainUrlParam = process.env.REACT_APP_DOMAIN_URL;
// const dispatch = useDispatch();

const initialState = {
  status: { type: 'success', class: 'disnone', status: '200', msg: '' },
  data: [],
};

function getIP() {
  return axios.get(`/${domainUrlParam}/getIp`);
}

export function* getChatList(action) {
  const list = yield select(state => state.chatList.data);
  const userChatCount = yield select(state => state.isActive.count);
  const userSatisYn = yield select(state => state.isActive.activeYn);

  let loadingId = '';

  if (action.payload.inLabel || action.payload.inStr) {
    yield put(
      insertChat({
        messageId: 'customer_' + list.length,
        createAt: moment().format('a hh:mm').replace('pm', '오후').replace('am', '오전'),
        messages: [{ text: action.payload.inLabel || action.payload.inStr }],
        chatType: 'customer',
        type: 'query',
        responseHidden: action.payload.responseHidden || 'N',
      })
    );

     yield put(activeCount());
  }

  if (action.payload.inLabel || action.payload.inStr || action.payload.inType === 'intro') {
    loadingId = 'loading_' + list.length;
    yield put(
      insertChat({
        messageId: loadingId,
        createAt: moment().format('a hh:mm').replace('pm', '오후').replace('am', '오전'),
        data: { response_status: 'loading' },
        chatType: 'bot',
        type: 'loading',
      })
    );
  }

  /*
  if (action.payload.inType === 'param') {
    console.log('all ::: ', action.payload);
    console.log('parameters ::: ', action.payload.parameters);
  }
  */

  if (!sessionStorage.getItem('user_id')) {
    const ipRes = yield call(getIP);
    if (ipRes.data === '::1') {
      ipRes.data = '127.0.0.1';
    }
    ipRes.data = ipRes.data.replace(/::ffff:/g, '').split(',')[0];
    sessionStorage.setItem('user_id', ipRes.data);
  }

  if (!sessionStorage.getItem('device')) {
    const filter = 'win16|win32|win64|mac|macintel';
    if (navigator.platform) {
      if (filter.indexOf(navigator.platform.toLowerCase()) < 0) {
        sessionStorage.setItem('device', 'mobile');
      } else {
        sessionStorage.setItem('device', 'pc');
      }
    }
  }

  if (!sessionStorage.getItem('session_id')) {
    sessionStorage.setItem('session_id', `session_${Uuid4()}`);
  }

  if (action.payload.parameters) {
    sessionStorage.setItem('latitude_y', action.payload.parameters.latitude_y);
    sessionStorage.setItem('longitude_x', action.payload.parameters.longitude_x);
  }

  const setParam = {
    user_id: sessionStorage.getItem('user_id'),
    in_type: action.payload.inType,
    in_str: action.payload.inStr,
    session_id: sessionStorage.getItem('session_id'),
    channel_id: sessionStorage.getItem('device'),
    parameters: action.payload.parameters ? action.payload.parameters : { latitude_y: '', longitude_x: '', position_status: 'N' },
  };

  try {
    const response = yield call(requestDMPost, setParam);
    const chatResult = response.data.data?.result?.fulfillment || {};
    const matchInfo = response.data.data?.result?.meta.core || {};
    const matchIntentId = matchInfo[0]?.intentId;
    const responseStatus = response.data.data?.result?.fulfillment?.response_status || '';
    const chatFlow = response.data.data?.result?.meta?.chatflow.id || '';
    // console.log("chatFLow",chatFlow);

    if (chatResult.custom_code.length > 0) {
      if (chatResult.custom_code.find(x => x.key === 'organization')) {
        if (chatResult.custom_code.find(x => x.key === 'organization').value === 'on') {
          yield put(isActiveOrganizationModal());
	}
      } else if (chatResult.custom_code.find(x => x.key === 'complaint')) {
        if (chatResult.custom_code.find(x => x.key === 'complaint').value === 'on') {
          yield put(isActiveComplaintModal(true));
        } else if (chatResult.custom_code.find(x => x.key === 'complaint').value === 'off') {
          yield put(isActiveComplaintModal(false));
        }
      } else if (chatResult.custom_code.find(x => x.key === 'complaint_search')) {
        if (chatResult.custom_code.find(x => x.key === 'complaint_search').value === 'on') {
          yield put(isActiveComplaintSearchModal(true));
        } else if (chatResult.custom_code.find(x => x.key === 'complaint_search').value === 'off') {
          yield put(isActiveComplaintSearchModal(false));
        }
      }
    }

    const loadingStatus = yield select(state => state.isActive.loading);
    if (loadingStatus) {
      yield put(loading(false));
    }

    // bot
    let messageForm = { id: response.data?.data?.message_id };
    if (response.status.type === 'success') {
      if (responseStatus === 'suggest') {
        messageForm = {
          ...messageForm,
          messageId: 'bot_' + list.length,
          createAt: moment().format('a hh:mm').replace('pm', '오후').replace('am', '오전'),
          data: {
            response_status: 'suggest',
            response_type: 'answer',
            emotion: chatResult.emotion,
            speech: chatResult.speech,
            template_id: '08_ListBT',
            messages: [
              {
                type: 'button',
                name: '버튼',
                id: 'list_btn',
                manual: 'N',
                random: 'N',
                items: chatResult.suggest.map(data => ({
                  button: {
                    label: data.sentence,
                    value: data.sentence,
                    action: 'query',
                  },
                })),
              },
            ],
          },
          chatType: 'bot',
        };
      } else {
        messageForm = {
          ...messageForm,
          messageId: 'bot_' + list.length,
          createAt: moment().format('a hh:mm').replace('pm', '오후').replace('am', '오전'),
          data: chatResult,
          intentId: matchIntentId,
          chatType: 'bot',
        };
      }
    } else if (response.status.type === 'error') {
      messageForm = {
        ...messageForm,
        messageId: 'bot_' + list.length,
        createAt: moment().format('a hh:mm').replace('pm', '오후').replace('am', '오전'),
        data: {
          response_status: 'error',
          response_type: 'answer',
          emotion: 'normal',
          speech: [{ text: '서버로 부터 응답을 받지를 못했습니다.' }, { text: '잠시 후 다시 시도해 주세요.' }],
          template_id: '',
          custom_code: [],
          suggest: [],
        },
        chatType: 'bot',
      };
    }

    yield put(changeChat({ id: loadingId, form: messageForm }));

    if(chatFlow === 'chatflow_791a1da8-4a55-4d1b-b2ac-339b2f1c4c9b' || chatFlow === 'chatflow_b53ef952-c8e3-4d87-8fba-19d2c4159be5'){
        yield put(activeCount({ resetId : 'reset'}));
    }
    if(userChatCount === 3 && userSatisYn !== true){
      yield put(activeCount({ setActiveYn : true }))
      yield put(isACtiveSatisfyModal());
     }

  } catch (err) {
    const errorStatus = { type: 'error', class: '', status: '400', msg: err };
    yield put({
      type: GET_CHAT_RESULT,
      payload: { ...initialState, status: errorStatus },
      error: true,
    });
  }
}

export function* getChatListSaga() {
  yield takeLatest(GET_CHAT_LIST, getChatList);
}

export default handleActions(
  {
    [RE_RENDER_CHAT]: state => {
      return { ...state };
    },
    [INSERT_CHAT]: (state, action) => {
      state.data = state.data.concat(action.payload);
      return { ...state };
    },
    [CHANGE_CHAT]: (state, action) => {
      const { id, form } = action.payload;
      const idx = state.data.findIndex(i => i.messageId === id);
      if (idx !== -1) state.data[idx] = form;
      return { ...state };
    },
    [GET_CHAT_RESULT]: (state, action) => ({
      data: action.payload.data,
      status: action.payload.status,
    }),
    [SET_CHAT_LIST]: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
  initialState
);
